module.exports = __webpack_public_path__ + "assets/Verletzung.bb965b50.png";